"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _widgets = require("@quarkly/widgets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Point = function Point(_ref) {
  var numb = _ref.numb,
      active = _ref.active,
      clickFunc = _ref.clickFunc,
      override = _ref.override;

  var clickEvent = function clickEvent() {
    return clickFunc(numb);
  };

  return /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({}, override('Point', "Point ".concat(numb), numb === active && 'Point :active'), {
    onClick: clickEvent
  }), /*#__PURE__*/_react["default"].createElement(_widgets.Icon, override('Point Icon', "Point Icon ".concat(numb), numb === active && 'Point Icon :active')));
};

var _default = Point;
exports["default"] = _default;